// src/pages/Marketplace/surge-pricing/EventsList.tsx
import React from 'react';
import { formatInMarketTz } from '@/pages/Marketplace/shared';
import type { SurgeEvent } from '@/pages/Marketplace/shared';

interface Props {
  events: SurgeEvent[];
  tz: string;
  onEdit: (e: SurgeEvent) => void;
  onDelete: (e: SurgeEvent) => void;
}

export default function EventsList({ events, tz, onEdit, onDelete }: Props): React.ReactElement {
  if (events.length === 0) {
    return <div className="text-sm text-gray-500 py-6 text-center">No events for this filter.</div>;
  }
  return (
    <div className="border border-gray-800 rounded-lg overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-gray-900 text-gray-400 text-xs uppercase">
          <tr>
            <th className="text-left px-3 py-2">Name</th>
            <th className="text-left px-3 py-2">×</th>
            <th className="text-left px-3 py-2">Starts</th>
            <th className="text-left px-3 py-2">Ends</th>
            <th className="text-left px-3 py-2">Notes</th>
            <th className="text-left px-3 py-2">By</th>
            <th className="text-right px-3 py-2"></th>
          </tr>
        </thead>
        <tbody>
          {events.map((e) => (
            <tr key={e.id} className="border-t border-gray-800">
              <td className="px-3 py-2">{e.name}</td>
              <td className="px-3 py-2">{e.multiplier}×</td>
              <td className="px-3 py-2 text-gray-400">{formatInMarketTz(e.starts_at, tz, 'PP p')}</td>
              <td className="px-3 py-2 text-gray-400">{formatInMarketTz(e.ends_at, tz, 'PP p')}</td>
              <td className="px-3 py-2 text-gray-400 max-w-[240px] truncate">{e.notes ?? '—'}</td>
              <td className="px-3 py-2 text-gray-400">{e.created_by_email}</td>
              <td className="px-3 py-2 text-right">
                <button onClick={() => onEdit(e)} className="text-xs text-violet-300 hover:text-violet-200 mr-3">Edit</button>
                <button onClick={() => onDelete(e)} className="text-xs text-red-300 hover:text-red-200">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
